import type {
  DetailedHTMLProps,
  FC,
  HTMLAttributes,
  PropsWithChildren,
} from 'react';

import type { ObjectType } from '@iconik-io/iconik-api/src/types/object_types';
import type { Permission } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

export type AnyObject = Record<string, any>;

export type PaginationOptions = {
  page: number;
  pages: number;
  total: number;
  per_page: number;
};

export type PermissionValues = Record<Permission, boolean>;

export const defaultPermissions: PermissionValues = {
  read: false,
  write: false,
  delete: false,
  'change-acl': false,
};

export const allGrantedPermissions: PermissionValues = {
  read: true,
  write: true,
  delete: true,
  'change-acl': true,
};

export type GenericHtmlProps = DetailedHTMLProps<
  HTMLAttributes<HTMLElement>,
  HTMLElement
>;

export type ObjectWithId = {
  id: string;
  [key: string]: any;
};

export type ObjectWithIdAndObjectType = {
  id: string;
  object_type: ObjectType;
  [key: string]: any;
};

export type FacetBucketSchema<FacetKey extends string = string> = {
  doc_count?: number;
  key: FacetKey;
  key_as_string?: FacetKey;
};

export type FacetSchema<FacetKey extends string = string> = {
  buckets?: FacetBucketSchema<FacetKey>[];
  doc_count_error_upper_bound?: number;
  sum_other_doc_count?: number;
  facetLabel?: string;
};

export type FacetsSchema<FacetKey extends string = string> = {
  [key: string]: FacetSchema<FacetKey>;
} & {
  current_facet_filters?: { [key: string]: FacetSchema<FacetKey> };
};

export type FCC<T = unknown> = FC<PropsWithChildren<T>>;
